document.addEventListener('DOMContentLoaded', function () {
  var roots = document.querySelectorAll('[data-events-calendar]');

  roots.forEach(function (root) {
    var sectionId = root.id.replace('EventsCalendar-', '');
    var dataEl = document.querySelector('[data-events-calendar-source="' + sectionId + '"]');
    if (!dataEl) return;

    var events = dataEl.textContent
      .split('\n')
      .map(function (line) { return line.trim(); })
      .filter(Boolean)
      .map(function (line) {
        try { return JSON.parse(line); } catch (e) { return null; }
      })
      .filter(Boolean);

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function dateKey(year, month, day) { return year + '-' + pad(month + 1) + '-' + pad(day); }
    function mapsUrl(location) { return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(location); }

    var pinSvg = '<svg class="ec-pin" viewBox="0 0 24 24" width="11" height="11" fill="currentColor" aria-hidden="true"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/></svg>';

    function eventMetaHtml(ev) {
      var html = '';
      if (ev.time) html += '<span class="ec-event__time">' + ev.time + '</span>';
      if (ev.location) {
        html += '<a class="ec-event__location" style="text-decoration:none !important;" href="' + mapsUrl(ev.location) + '" target="_blank" rel="noopener">' + pinSvg + ev.location + '</a>';
      }
      return html;
    }

    function scheduleByDate(ev) {
      var map = {};
      if (ev.schedule && ev.schedule.length) {
        ev.schedule.forEach(function (s) { if (s.date) map[s.date] = s; });
      }
      return map;
    }

    var multiDayEvents = events.filter(function (ev) { return ev.endDate && ev.endDate !== ev.date; });

    var singleDayEventsByDate = {};
    events.forEach(function (ev) {
      if (ev.endDate && ev.endDate !== ev.date) return;
      if (!singleDayEventsByDate[ev.date]) singleDayEventsByDate[ev.date] = [];
      singleDayEventsByDate[ev.date].push(ev);
    });

    var today = new Date();
    var state = { year: today.getFullYear(), month: today.getMonth() };

    var weekdayLabels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var monthLabels = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'];

    function render() {
      var year = state.year, month = state.month;
      var firstWeekday = new Date(year, month, 1).getDay();
      var daysInMonth = new Date(year, month + 1, 0).getDate();

      var html = '';
      html += '<div class="ec-head"><h3>' + monthLabels[month] + ' ' + year + '</h3>';
      html += '<div class="ec-nav">';
      html += '<button type="button" data-ec-prev aria-label="Previous month">&#8249;</button>';
      html += '<button type="button" data-ec-next aria-label="Next month">&#8250;</button>';
      html += '</div></div>';

      html += '<div class="ec-weekdays">';
      weekdayLabels.forEach(function (d) { html += '<span>' + d + '</span>'; });
      html += '</div>';

      var cells = [];
      for (var i = 0; i < firstWeekday; i++) cells.push(null);
      for (var day = 1; day <= daysInMonth; day++) cells.push({ day: day, key: dateKey(year, month, day) });
      while (cells.length % 7 !== 0) cells.push(null);

      var weeks = [];
      for (var w = 0; w < cells.length; w += 7) weeks.push(cells.slice(w, w + 7));

      html += '<div class="ec-grid">';
      weeks.forEach(function (weekCells) {
        var handledCols = {};
        var barsHtml = '';
        multiDayEvents.forEach(function (ev) {
          var startCol = -1, endCol = -1;
          var segmentCells = [];
          weekCells.forEach(function (cell, colIndex) {
            if (!cell) return;
            if (cell.key >= ev.date && cell.key <= ev.endDate) {
              if (startCol === -1) startCol = colIndex;
              endCol = colIndex;
              handledCols[colIndex] = true;
              segmentCells.push(cell);
            }
          });
          if (startCol !== -1) {
            var schedMap = scheduleByDate(ev);
            var hasSchedule = segmentCells.some(function (c) { return schedMap[c.key]; });
            var numsHtml = '<div class="ec-bar-nums" style="grid-template-columns:repeat(' + segmentCells.length + ',1fr);">';
            segmentCells.forEach(function (c) { numsHtml += '<span class="ec-bar-num">' + c.day + '</span>'; });
            numsHtml += '</div>';
            var innerHtml = numsHtml + '<a class="ec-bar__title" href="' + ev.url + '">' + ev.title + '</a>';
            if (hasSchedule) {
              innerHtml += '<div class="ec-bar-days" style="grid-template-columns:repeat(' + segmentCells.length + ',1fr);">';
              segmentCells.forEach(function (c) {
                var s = schedMap[c.key];
                innerHtml += '<div class="ec-bar-day">';
                if (s && s.time) innerHtml += '<span class="ec-bar-day__time">' + s.time + '</span>';
                if (s && s.location) innerHtml += '<a class="ec-bar-day__loc" style="text-decoration:none !important;" href="' + mapsUrl(s.location) + '" target="_blank" rel="noopener">' + pinSvg + s.location + '</a>';
                innerHtml += '</div>';
              });
              innerHtml += '</div>';
            } else {
              innerHtml += '<span class="ec-bar-hint">' + pinSvg + 'Click for details</span>';
            }
            barsHtml += '<div class="ec-bar" style="grid-column:' + (startCol + 1) + ' / ' + (endCol + 2) + ';">' + innerHtml + '</div>';
          }
        });

        var daysHtml = '';
        weekCells.forEach(function (cell, colIndex) {
          if (!cell) {
            daysHtml += '<div class="ec-day ec-day--pad" style="grid-column:' + (colIndex + 1) + ';">&nbsp;</div>';
            return;
          }
          if (handledCols[colIndex]) return;
          var singleEvents = singleDayEventsByDate[cell.key] || [];
          var dayClass = singleEvents.length > 0 ? ' ec-day--has-event' : '';
          daysHtml += '<div class="ec-day' + dayClass + '" style="grid-column:' + (colIndex + 1) + ';">';
          daysHtml += '<span class="ec-day__num">' + cell.day + '</span>';
          singleEvents.forEach(function (ev) {
            daysHtml += '<div class="ec-event">';
            daysHtml += '<a class="ec-event__title" href="' + ev.url + '">' + ev.title + '</a>';
            daysHtml += eventMetaHtml(ev);
            daysHtml += '</div>';
          });
          daysHtml += '</div>';
        });

        html += '<div class="ec-week"><div class="ec-week-days">' + barsHtml + daysHtml + '</div></div>';
      });
      html += '</div>';
      if (events.length === 0) html += '<div class="ec-empty-state">No upcoming events yet.</div>';

      root.innerHTML = html;

      var prevBtn = root.querySelector('[data-ec-prev]');
      var nextBtn = root.querySelector('[data-ec-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () {
        state.month -= 1;
        if (state.month < 0) { state.month = 11; state.year -= 1; }
        render();
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        state.month += 1;
        if (state.month > 11) { state.month = 0; state.year += 1; }
        render();
      });
    }

    render();
  });
});
